import { TabsRoot } from "ui/tabs/tabs.styles";
import { type TabsProps } from "ui/tabs/tabs.types";

/**
 * MUI's `Tabs` on Figma's three strips (`Tabs` page, `23684:13727`). The strip owns every tab's look, so
 * `appearance` and `size` are set here and not on `Tab`.
 */
export const Tabs = ({ appearance = "top-bar", size = "medium", ref, ...rest }: TabsProps) => (
  <TabsRoot ref={ref} appearance={appearance} size={size} {...rest} />
);
